import { HttpClient } from "./HttpClient";

export interface WorkspaceSettings {
    agentsCanInitiateConvo: boolean;
    autoRepliesEnabled: boolean;
    copilotsEnabled: boolean;
    detectAutomatedReplies: boolean;
    excludedTeamsFromCopilot: string[];
    forwardUseOriginalSender: boolean;
    summariesEnabled: boolean;
    useAgentNamesInEmailsInEmails: boolean;
    writingToolsEnabled: boolean;
}

export const workspaceSettingsService = {
    async getWorkspaceSettings(): Promise<WorkspaceSettings> {
        const response = await HttpClient.apiClient.get('/setting');
        const data = response.data?.data

        return data;
    },

    async updateWorkspaceSettings(
        partialSettings: Partial<WorkspaceSettings>
    ): Promise<boolean> {
        const response = await HttpClient.apiClient.post('/setting', {
            ...partialSettings
        });

        return response.data?.success ?? false;
    }
};